import { Box, Text } from '@chakra-ui/react';

import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';

import type { PriceCardFeature, PriceCardUspsVariant } from '../utils/get-price-card-features';
import { shouldShowSubline } from '../utils/get-price-card-features';

type PriceCardUspProps = {
  feature: PriceCardFeature;
  variant: PriceCardUspsVariant;
};

export function PriceCardUsp({ feature, variant }: PriceCardUspProps) {
  if (typeof feature === 'string') {
    return (
      <HeadingWithEmphasis
        text={feature}
        emphasisProps={{
          fontWeight: '600',
        }}
        headingProps={{
          as: 'span',
          fontFamily: 'body',
          fontSize: 'md',
          fontWeight: '400',
        }}
      />
    );
  }

  const showSubline = shouldShowSubline(variant);

  return (
    <Box display='flex' flexDirection='column' gap={showSubline ? 0 : undefined}>
      <Text as='span' fontFamily='body' fontSize='md' fontWeight='600'>
        {feature.title}
      </Text>
      {showSubline && (
        <Text color='supportGray.70' fontFamily='body' fontSize='sm' fontWeight='400' lineHeight='short'>
          {feature.subline}
        </Text>
      )}
    </Box>
  );
}
